<template>
    <div>
        <modal v-if="showModal" :data="activeRepeaterRegistration" :modalType="modalType" :topbar="topbar" :userAction="userAction" @setSelectedTopbar="setSelectedTopbar" @close="closeModal"></modal>
        <div class="repeater">
            <div class="columns is-mobile">
                <div class="column is-four-fifths flexbox-centertext">
                    <p>{{formElement.label}}</p>
                </div>
                <div class="column repeater-add">
                    <div class="plus-icon" @click="openModal('modal-repeater', formElement, 'create')">
                        <icon class="small-svg" name="plus"></icon>
                    </div>
                </div>
            </div>
            <div v-if="repeater" class="columns list-repeater is-multiline is-mobile">
                <div class="column is-12 list-item-repeater" v-for="(element, index) in repeaterItems" :key="index">
                    <div class="columns is-mobile">
                        <div @click="openModal('modal-repeater', element, 'update')" class="column is-four-fifths flexbox-centertext">
                            <span>{{element.title ? element.title : 'Ingen titel'}}</span>
                        </div>
                        <div @click="removeRepeaterItem(element, index)" class="column">
                            <div class="plus-icon">
                                <icon class="small-svg" name="remove"></icon>
                            </div>
                        </div>
                        <div class="top-right-item">
                            {{element.lastModifiedDatetime | formatDateWithTime}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import modal from "./../../shared/modal/modal";

export default {
  name: "kollecto-repeater",
  props: ["formElement", "userActionComponent"],
  components: {
    modal
  },
  data() {
    return {
      showModal: false,
      modalType: null,
      modalData: null,
      userAction: null,
      topbar: []
    };
  },
  computed: {
    ...mapGetters({
      repeater: "getRepeaterItems",
      activeRepeaterRegistration: "getActiveRepeaterRegistration",
      activeRegistration: "getActiveRegistration"
    }),
    repeaterItems() {
      if (this.repeater.length > 0) {
        return this.repeater.filter(
          el => el.repeaterId === this.formElement.formElementId
        );
      }
      return false;
    }
  },
  methods: {
    ...mapActions({
      toggleModal: "toggleModal",
      setActiveRepeaterRegistration: "setActiveRepeaterRegistration"
    }),
    openModal(view, data, userAction) {
      this.userAction = userAction;
      let copy = JSON.parse(JSON.stringify(data));
      // let copy = Object.assign({}, data);
      this.setActiveRepeaterRegistration({
        activeRegistration: this.activeRegistration,
        repeaterRegistration: copy,
        userAction: userAction
      });
      this.setSelectedTopbar(this.topbar[0]);
      this.toggleModal(true);
      this.modalType = view;
      this.showModal = true;
    },
    removeRepeaterItem(repeater, index) {
      if (repeater.repeaterId === this.repeater[index]) {
        this.repeater.splice(index, 1);
      } else {
        let found = false;
        this.repeater.forEach((rep, idx) => {
          if (!found) {
            if (rep.repeaterId === repeater.repeaterId) {
              this.repeater.splice(idx, 1);
              found = true;
            }
          }
        });
      }
    },
    closeModal() {
      this.showModal = false;
      this.toggleModal(false);
      this.setActiveRepeaterRegistration({ userAction: "clear" });
    },
    setSelectedTopbar(item) {
      this.topbar.forEach(el => {
        if (item.id === el.id) {
          el.selected = true;
        } else {
          el.selected = false;
        }
      });
    }
  },
  created() {
    this.topbar.push(
      { id: 1, name: this.$t("formular"), selected: true },
      { id: 2, name: this.$t("position"), selected: false },
      { id: 3, name: this.$t("images"), selected: false }
    );
  }
};
</script>
